import { FaLayerGroup } from "react-icons/fa";
import "./FieldsSection.css";

const fieldsData = [
  {
    id: "spa-chuyen-nghiep",
    title: "Spa chuyên nghiệp",
    image: "/images/home/fields/suc-khoe-sac-dep/field1.webp",
  },
  {
    id: "cham-soc-da",
    title: "Chăm sóc da",
    image: "/images/home/fields/suc-khoe-sac-dep/field2.webp",
  },
  {
    id: "phun-xam-tham-my",
    title: "Phun xăm thẩm mỹ",
    image: "/images/home/fields/suc-khoe-sac-dep/field3.webp",
  },
  {
    id: "goi-dau-duong-sinh",
    title: "Gội đầu dưỡng sinh",
    image: "/images/home/fields/suc-khoe-sac-dep/field4.webp",
  },
  {
    id: "massage-chuyen-nghiep",
    title: "Massage chuyên nghiệp",
    image: "/images/home/fields/suc-khoe-sac-dep/field5.webp",
  },
  {
    id: "noi-mi-chuyen-nghiep",
    title: "Nối mi chuyên nghiệp",
    image: "/images/home/fields/suc-khoe-sac-dep/field6.webp",
  },
  {
    id: "trang-diem",
    title: "Trang điểm",
    image: "/images/home/fields/suc-khoe-sac-dep/field7.webp",
  },
  {
    id: "nail-va-ve-mong",
    title: "Nail và vẽ móng",
    image: "/images/home/fields/suc-khoe-sac-dep/field8.webp",
  },
  {
    id: "quan-ly-spa",
    title: "Quản lý Spa",
    image: "/images/home/fields/suc-khoe-sac-dep/field9.webp",
  },
];

const FieldsSection = () => {
  return (
    <section className="fields">
      <div className="fields__container">
        <div className="fields__icon">
          <FaLayerGroup />
        </div>
        <p className="fields__sub-title">ĐÀO TẠO CHỨNG CHỈ QUỐC GIA</p>
        <h2 className="fields__title">Lĩnh vực sức khỏe và chăm sóc sắc đẹp</h2>

        <div className="fields__cards">
          {fieldsData.map((field) => (
            <div
              key={field.id}
              className="field-card"
              id={field.id}
            >
              <div className="field-card__image">
                <img
                  src={field.image}
                  alt={field.title.replace(/\n/g, " ")}
                  loading="lazy"
                />
              </div>
              <h3 className="field-card__title">
                {field.title.split("\n").map((line, i) => (
                  <span key={i}>
                    {line}
                    {i !== field.title.split("\n").length - 1 && <br />}
                  </span>
                ))}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FieldsSection;
